import { registerPlugin } from '@capacitor/core';

import { PrivacyPluginType } from './types';

export const Privacy = registerPlugin<PrivacyPluginType>('PrivacyPlugin', {
  android: () => import('./android').then((m) => new m.PrivacyPluginAndroid()),
  web: () => import('./web').then((m) => new m.PrivacyPluginWeb()),
  ios: () => import('./ios').then((m) => new m.PrivacyPluginIOS()),
});
